module.exports = __webpack_public_path__ + "img/badge_danger.f14fd0c4.svg";